import React, { memo, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import utils from '../../utils/utils';
import GuaranteeSlotsModal from '../shifts/GuaranteeShift/GuaranteeSlotsModal';
import { isOpenSlot } from './shiftActionSlots';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';
import { showNotification } from '../../redux/notification';

const GuaranteeShiftMenuItem = ({ shift }) => {
	const [showGuaranteedModal, setShowGuaranteedModal] = useState(false);
	const { shiftId, isRecurring, rawShift } = shift.routeData[GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND];
	const dispatch = useDispatch();

	if (!shiftId) {
		return null;
	}

	const resourceType = `${rawShift.shift_resource_type}${
		rawShift.shift_specialty ? ` - ${rawShift.shift_specialty}` : ''
	}`;
	const slots = rawShift.slots.filter(isOpenSlot).map((slot) => ({
		...slot,
		resource_type: resourceType,
		facility_name: rawShift.facility_name,
		facility_timezone: rawShift.facility_timezone,
		start_time_at_utc: rawShift.start_time,
		end_time_at_utc: rawShift.end_time,
		shift_id: rawShift.shift_id,
		isRecurring
	}));

	const hasUnguaranteedSlots = slots.some((s) => !s.is_guaranteed);

	const onSaveChangesGuaranteed = async (newGuaranteedStatus) => {
		setShowGuaranteedModal(false);
		dispatch(showNotification('success', `Guarantee ${newGuaranteedStatus ? 'set' : 'removed'} successfully.`));
	};

	const onErrorChangesGuaranteed = (e) => {
		const errorMessage = utils.parseRTKQueryValidationError(e, 'Failed to update shift. Please try again!');
		dispatch(showNotification('error', errorMessage));
		setShowGuaranteedModal(false);
	};

	return [
		<Dropdown.Item
			key="guarantee-gs-action-menu-item"
			className="action-menu-item"
			onClick={() => setShowGuaranteedModal(true)}
		>
			{hasUnguaranteedSlots ? 'Guarantee shifts' : 'Remove shift guarantees'}
		</Dropdown.Item>,

		showGuaranteedModal && (
			<GuaranteeSlotsModal
				key="guaranteed-modal"
				shiftData={slots[0]}
				slots={slots}
				onError={onErrorChangesGuaranteed}
				onSaveChanges={onSaveChangesGuaranteed}
				resourceType={shift.resource_type}
				onCancel={() => setShowGuaranteedModal(false)}
			/>
		)
	];
};

export default memo(GuaranteeShiftMenuItem);
